const modulo_productos = {
	strict: false,

  state:{
    canales:[],
	familias:[],
	max_precio:1000000
  },

	getters: {
		getcanales: state => state.canales,
		getfamilias: state => state.familias,
		getmaxprecioproducto: state =>state.max_precio,
	},

	mutations: {
		get_canales: (state, canales) => {
			state.canales = canales
		},
		get_familias: (state,familias) =>{
			state.familias = familias
		},
		get_max_producto: (state,precio) =>{
			state.max_precio = precio
		}
	},

	actions: {
		getCanales: (context, vm) => {
			axios.get('api/getcanales').then(res => {        
				context.commit('get_canales', res.data)
			}, res => {

			})
		},
		getFamilias: (context, vm) => {
			axios.get('api/getfamilias').then(res => {        
				context.commit('get_familias', res.data.Familias)
			}, res => {

			})
		},
		getMaxPrecioProducto: (context, vm) => {
			axios.get('api/getMaxPrecioProducto').then(res => {        
				context.commit('get_max_producto', res.data)
			}, res => {

			})
		},
	}
}

export default modulo_productos;
